import apiService from './api';

class DashboardServices {
  async getDashboardList(): Promise<any> {
    try {
      const response = await apiService.getDashboardList();
      return response.data;
    } catch (error) {
      console.error('获取仪表盘列表失败:', error);
      throw error;
    }
  }

  /* 创建仪表盘 */
  async createDashboard(data: any): Promise<any> {
    try {
      const response = await apiService.createDashboard(data);
      return response.data;
    } catch (error) {
      console.error('创建仪表盘失败:', error);
      throw error;
    }
  }

  async getDashboard(dashboardId: string): Promise<any> {
    try {
      const response = await apiService.get(`/dashboard/${dashboardId}`);
      return response.data;
    } catch (error) {
      console.error('获取仪表盘失败:', error);
      throw error;
    }
  }

  /* 获取仪表盘图表 */
  async getDashboardCharts(dashboardId: number): Promise<any> {
    try {
      const response = await apiService.getDashboardCharts(dashboardId);
      return response.data;
    } catch (error) {
      console.error('获取仪表盘图表失败:', error);
      throw error;
    }
  }

  /* 创建仪表盘图表 */
  async createDashboardChart(data: any): Promise<any> {
    try {
      const response = await apiService.createDashboardChart(data);
      return response.data;
    } catch (error) {
      console.error('创建仪表盘图表失败:', error);
      throw error;
    }
  }

  /* 更新仪表盘图表 */
  async updateDashboardChart(chartId: number, data: any): Promise<any> {
    try {
      const response = await apiService.updateDashboardChart(chartId, data);
      return response.data;
    } catch (error) {
      console.error('更新仪表盘图表失败:', error);
      throw error;
    }
  }
  /* 删除仪表盘图表 */
  async deleteDashboardChart(chartId: number): Promise<any> {
    try {
      const response = await apiService.deleteDashboardChart(chartId);
      return response.data;
    } catch (error) {
      console.error('删除仪表盘图表失败:', error);
      throw error;
    }
  }
}

export default new DashboardServices();
